module.exports = __webpack_public_path__ + "img/left-box-es.49e36ca1.png";